<template>
  <svg
    width="0"
    height="0"
    style="display: none;"
    v-html="$options.svgSprite"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

// CHECK: (https://css-tricks.com/a-font-like-svg-icon-system-for-vue/)

const svgContext = require.context(
  '!svg-inline-loader?' + '!@/assets/images/icons-fixed-color', // search this directory
  true, // search subdirectories
  /\w+\.svg$/i // only include SVG files
)
const symbols = svgContext.keys().map(path => {
  // get SVG file content
  const content = svgContext(path)
  // extract icon id from filename
  const id = path.replace(/^\.\/(.*)\.\w+$/, '$1')
  // replace svg tags with symbol tags and id attribute
  return content
    .replace('<svg', `<symbol id="fixed-color-${id}"`) // 注意：這裡加了 fixed-color 前綴，以免跟 SvgIcon 同 id 名
    .replace('svg>', 'symbol>')
})

export default defineComponent({
  name: 'SvgSprite',
  svgSprite: symbols.join('\n') // concatenate all symbols into $options.svgSprite
})
</script>
